import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ShoppingCart } from "lucide-react";
import { useLanguageStore } from "@/stores/language";
import { forwardRef } from "react";

interface CartTriggerButtonProps {
  totalItems: number;
  onClick?: () => void;
}

export const CartTriggerButton = forwardRef<HTMLButtonElement, CartTriggerButtonProps>(
  ({ totalItems, onClick }, ref) => {
    const { t } = useLanguageStore();
    
    const ariaLabel = totalItems === 0
      ? t("Shopping cart, empty", "Carrito de compras, vacío")
      : totalItems === 1
        ? t("Shopping cart, 1 item", "Carrito de compras, 1 artículo")
        : t(`Shopping cart, ${totalItems} items`, `Carrito de compras, ${totalItems} artículos`);

    return (
      <Button 
        ref={ref}
        variant="outline" 
        size="icon" 
        className="relative"
        onClick={onClick}
        aria-label={ariaLabel}
        data-testid="cart-trigger"
      >
        <ShoppingCart className="h-5 w-5" aria-hidden="true" />
        {totalItems > 0 && (
          <Badge 
            className="absolute -top-2 -right-2 h-5 w-5 rounded-full p-0 flex items-center justify-center text-xs bg-accent text-accent-foreground"
            aria-hidden="true"
          >
            {totalItems}
          </Badge>
        )}
      </Button>
    );
  }
);

CartTriggerButton.displayName = "CartTriggerButton";
